import request from '@/utils/request'
import {clearLocalStorage} from '@/utils'

export function login (data) {
  return request({
    url: '/admin/user/login',
    method: 'post',
    dataType: 'urlencoded',
    params: data
  })
}
export function getUserMenus (data) {
  return request({
    url: '/admin/menus/build',
    method: 'get',
  })
}

// export function getInfo (token) {
//  return request({
//    url: '/admin/user/info',
//    method: 'get',
//    params: { token }
//  })
// }

export function logout () {
  return request({
    url: '/admin/user/logout',
    method: 'get'
  }).then(res=>{
    clearLocalStorage()
  }).catch(err=>{
    clearLocalStorage()
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js